import type { LiveUpdate } from '@/components/LiveBlogUpdates'

/** Complete snapshots can remove deleted entries; legacy windows only add/correct. */
export function reconcileLiveHistory(previous: LiveUpdate[], incoming: unknown, historyComplete: boolean): LiveUpdate[] {
  if (!Array.isArray(incoming)) return previous
  const byId = new Map<number, LiveUpdate>(historyComplete ? [] : previous.map((update) => [update.id, update]))
  let validRows = 0
  for (const value of incoming) {
    if (!value || typeof value !== 'object') continue
    const update = value as Record<string, unknown>
    const timestamp = typeof update.createdAt === 'string' ? Date.parse(update.createdAt) : NaN
    if (!Number.isSafeInteger(update.id) || Number(update.id) <= 0 || typeof update.body !== 'string' || !Number.isFinite(timestamp)) continue
    validRows++
    byId.set(Number(update.id), {
      id: Number(update.id), body: update.body, createdAt: new Date(timestamp).toISOString(),
      title: typeof update.title === 'string' ? update.title : null,
      image: typeof update.image === 'string' ? update.image : null,
      video: typeof update.video === 'string' ? update.video : null,
    })
  }
  // A damaged non-empty payload is not an authoritative deletion of all history.
  if (incoming.length && !validRows) return previous
  return Array.from(byId.values()).sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt) || b.id - a.id)
}
